import _unset from 'lodash/fp/unset';
import { ImmutableObject } from 'ia-react-core/~/interfaces/ImmutableObject';

import get from './get';
import set from './set';

/**
 * @visibleName unset
 * @since 0.19.2
 * @component
 */
export default function unset(object: object, path: string | string[]) {
  const normalizedPath = Array.isArray(path) ? path : path.split('.');
  // Duck checking immutable.js
  if (object && 'deleteIn' in object) {
    return (object as ImmutableObject).deleteIn(normalizedPath);
  }

  const targetPath = normalizedPath.slice(0, -1);
  const target = targetPath.length ? get(object, targetPath) : object;

  if (Array.isArray(target)) {
    const [index] = normalizedPath.slice(-1);
    const targetCopy = target.concat();
    targetCopy.splice(Number(index), 1);

    if (targetPath.length) {
      return set(object, targetPath, targetCopy);
    }

    return targetCopy;
  }

  return _unset(path, object);
}
